import { sharedMessages } from '@app/translations';

export const getTabsI18n = ({ $t }) => ({
  scrollControlStartTitle: $t(sharedMessages.scrollBackward),
  scrollControlEndTitle: $t(sharedMessages.scrollForward),
});
